module.exports = __webpack_public_path__ + "media/icons/close-circle-8aba6719.svg";